import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { target: String };

  connect() {
    console.log('ScrollToTop controller connected');
  }

  scrollToTop(event) {
    if (event) {
      event.preventDefault();
    }

    console.log('ScrollToTop triggered');

    // Se houver um target específico definido
    if (this.hasTargetValue && this.targetValue) {
      const targetElement = document.getElementById(this.targetValue);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }

    // Caso contrário, vai para o topo da página
    window.scrollTo({ top: 0, behavior: 'smooth' });
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
}
